const initialState = {
  loading: false,
  loaded: false,
  pictures: []
}

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'ADD_PICTURE': {
      return {
        ...state,
        pictures: [...state.pictures, action.payload.picture]
      }
    }

    case 'REMOVE_PICTURE': {
      return {
        ...state,
        pictures: state.pictures.filter(picture => picture.uid !== action.payload.uid)
      }
    }

    default : {
      return state
    }
  }
}
